import { render, staticRenderFns } from "./FormRadioFieldNames.vue?vue&type=template&id=f31d730a&"
import script from "./FormRadioFieldNames.vue?vue&type=script&lang=js&"
export * from "./FormRadioFieldNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports